export enum KEYBOARD_KEYS {
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  BACKSPACE = 'Backspace',
  HOME = 'Home',
  END = 'End',
}
